export function encryptData(data) {
    return btoa(data);
}

export function decryptData(ciphertext) {
    try {
        return atob(ciphertext);
    }
    catch (error) {
        return false
    }
}